module.exports = __webpack_public_path__ + "img/color-12.76b8de0.png";